import { useTranslation } from 'react-i18next';
import { BUTTON_SOURCES } from '@/constants/buttonSources';
import { useCheckoutContext } from '@/context/CheckoutContext/CheckoutContext';
import { useBrowserUserId } from '@/hooks/useBrowserUserId';
import { useLanguage } from '@/hooks/useLanguage';
import useValidateQueryParams from '@/hooks/useValidateQueryParams';
import { trackButtonClick } from '@/utils/gtmButtonClicked';
import styles from './SplitButton.module.scss';

interface Props {
  onClick: () => void;
  orderId: string;
  isSplitExist?: boolean;
}

export const SplitButton = ({ onClick, orderId, isSplitExist }: Props) => {
  const { t } = useTranslation();
  const { queryParams } = useValidateQueryParams();
  const { brandId, tableNumber, counterNumber } = queryParams();
  const { state } = useCheckoutContext();
  const browserUserId = useBrowserUserId();
  const { isRTL } = useLanguage();

  // An items split has numberOfSplits === 0 — its activity signal is splitType
  const isSplitActive = state.numberOfSplits > 0 || state.splitType === 'SPLIT_BY_ITEMS';
  const buttonText = isSplitActive
    ? t('checkout.splitBill.editSplit')
    : t('checkout.splitBill.splitBill');

  const isGooglePay = state.paymentMethod === 'GOOGLE_PAY';

  const handleClick = () => {
    trackButtonClick({
      buttonId: 'split-bill',
      buttonName: buttonText,
      buttonSource: BUTTON_SOURCES.MAIN_SCREEN,
      urlParams: {
        brandId: brandId || undefined,
        orderId: orderId || undefined,
        tableNumber,
        counterNumber,
      },
      extraParams: {
        split_created: isSplitExist ? 'yes' : 'no',
        source: 'web_kitopay_payment_screen',
        browser_user_id: browserUserId,
      },
    });
    onClick();
  };

  return (
    <div>
      <button
        className={`${styles.splitButton} ${isRTL && styles.rtl} ${isGooglePay && styles.googlePay}`}
        onClick={handleClick}
        data-testid="split-bill-button"
      >
        {buttonText}
      </button>
    </div>
  );
};
